import { render, staticRenderFns } from "./FolderNew.vue?vue&type=template&id=cbba832e&lang=pug&"
import script from "./FolderNew.vue?vue&type=script&lang=ts&"
export * from "./FolderNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports